// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import ApexCharts from "apexcharts"
import "cally"
import "./controllers"

// Expose ApexCharts globally so Stimulus controllers / inline views can use it.
window.ApexCharts = ApexCharts
